import { useState } from "react";
import { Outlet } from "react-router-dom";
import { MobileDrawer, MobileNav } from "./MobileNav";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export const AppShell = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    return (
        <div className="min-h-screen bg-nx-ink font-sans text-nx-text antialiased" data-testid="app-shell">
            <Sidebar />
            <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
            <div className="lg:pl-60">
                <Topbar onMenu={() => setDrawerOpen(true)} />
                <main className="mx-auto w-full max-w-[1400px] px-4 pb-28 pt-6 sm:px-6 lg:px-8 lg:pb-12">
                    <Outlet />
                </main>
            </div>
            <MobileNav onMenu={() => setDrawerOpen(true)} />
        </div>
    );
};
